import React, {memo, useCallback, useRef} from 'react';
import styled from 'styled-components';
import SocketComponent from '../Socket';
import ReactionDisplay from './ReactionDisplay';

function ReactionPicker({room}) {
    const timeoutRef = useRef();
    const [expanded, setExpanded] = React.useState(false);
    const socketRef = useRef(null);
    const reactionRef = React.useRef(null);
    const [isConnected, setIsConnected] = React.useState(false);
    const [count, setCount] = React.useState(0);

    const onMainHover = useCallback(() => {
        console.log('enter');
        if (expanded) return;
        //if user keeps mouse on first element, expand this after 1 second
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
            setExpanded(true);
        }, 1000);
    }, [expanded]);

    const onLeave = useCallback(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setExpanded(false);
    }, []);

    const onClickItem = useCallback(
        id => {
            onMainHover();

            if (socketRef.current) {
                socketRef.current.sendMessage(String(id));
            }

            if (reactionRef.current) {
                reactionRef.current.addReaction(String(id), id);
            }
        },
        [onMainHover],
    );

    const onConnect = useCallback(() => {
        console.log('onConnect');
        setIsConnected(true);
    }, []);

    const onDisconnect = useCallback(() => {
        console.log('onDisconnect');
        setIsConnected(false);
    }, []);

    const onEvent = useCallback(event => {
        console.log('onEvent', event);
        if (reactionRef.current) {
            reactionRef.current.addReaction(String(event.reaction), false);
        }
    }, []);

    return (
        <>
            <SocketComponent
                ref={socketRef}
                room={room}
                onConnect={onConnect}
                onDisconnect={onDisconnect}
                onCountChange={setCount}
                onEvent={onEvent}
            />
            {isConnected && (
                <>
                    <Container onMouseLeave={onLeave} expanded={expanded}>
                        <Background />
                        <InnerContainer>
                            <Icon
                                main
                                title="Love"
                                icon={require('../../assets/reactions/reaction_1.png')}
                                width={40}
                                height={37}
                                onMouseEnter={onMainHover}
                                onSendEvent={onClickItem}
                                id={1}
                            />
                            <Icon
                                title="Live"
                                icon={require('../../assets/reactions/reaction_2.png')}
                                width={49}
                                height={65}
                                id={2}
                                onSendEvent={onClickItem}
                            />
                            <Icon
                                title="Laugh"
                                icon={require('../../assets/reactions/reaction_3.png')}
                                width={50}
                                height={42}
                                id={3}
                                onSendEvent={onClickItem}
                            />
                            <Icon
                                title="Wow"
                                icon={require('../../assets/reactions/reaction_4.png')}
                                width={46}
                                height={38}
                                id={4}
                                onSendEvent={onClickItem}
                            />
                            <Icon
                                title="Heart Eyes"
                                icon={require('../../assets/reactions/reaction_5.png')}
                                width={37}
                                height={42}
                                id={5}
                                onSendEvent={onClickItem}
                            />
                        </InnerContainer>
                    </Container>
                    <ReactionDisplay ref={reactionRef} count={count} />
                </>
            )}
        </>
    );
}

const Container = styled.div`
    display: flex;
    position: absolute;
    right: 25px;
    bottom: 25px;
    width: ${({expanded}) => (expanded ? 375 : 65)}px;
    height: 160px;
    transition: all 0.3s ease-in-out;
    overflow: hidden;
    align-items: flex-end;
    z-index: 1001;
`;

const Background = styled.div`
    position: absolute;
    width: 100%;
    height: 65px;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 35px;
`;

const InnerContainer = styled.div`
    position: absolute;
    bottom: 12px;
    right: 12px;
    width: 345px;
    height: 100px;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: flex-end;
`;

const Icon = ({id, main, icon, width, height, title, ...props}) => {
    const _onClick = () => {
        props.onSendEvent && props.onSendEvent(id);
    };

    return (
        <IconContainer main={main} {...props} onClick={_onClick}>
            <Title height={height} className="child">
                {title}
            </Title>
            <IconImage src={icon} width={width} height={height} />
        </IconContainer>
    );
};

const IconContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    :hover > .child {
        opacity: 1;
    }
`;

const IconImage = styled.img`
    height: ${props => props.height}px !important;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.27, 0, 0.35, 1.47);
    :hover {
        transform: scale(1.6) translateY(${props => props.height * -0.15}px);
    }
`;

const Title = styled.div`
    display: flex;
    font-family: AvenirNextRoundedStd, Helvetica, Arial, sans-serif;
    font-weight: 700;
    font-size: 10px
    background-color: rgba(0, 0, 0, 0.75);
    border-radius: 2px;
    padding: 2px 4px;
    align-self: center;
    position: absolute;
    bottom: ${props => props.height * 1.6 + 8}px;
    white-space: nowrap;
    opacity: 0;
    transition: all 0.3s cubic-bezier(0.27, 0, 0.35, 1.47);
    pointer-events: none;
`;

export default memo(ReactionPicker);
